/**
 * Custom content constants shared across pages and components.
 */

/** Course type value for Code of Conduct courses */
export const CODE_OF_CONDUCT_COURSE_TYPE = 'Code of Conduct';

/** Course type value for Standalone courses courses */
export const STANDALONE_COURSES_TYPE = 'Standalone courses';

/** API / UI category key for Code of Conduct courses (compliance_education catalog). */
export const CODE_OF_CONDUCT_COURSE_CATEGORY = 'code-of-conduct';

/**
 * Default libraryId assigned to Code of Conduct courses.
 * Code of Conduct does not require a topic name (libraryId) from the user,
 * but the backend requires a non-null libraryId — so we use this placeholder.
 */
export const CODE_OF_CONDUCT_LIBRARY_ID = 'MOD019';

/** True when the library id is the internal Code of Conduct module placeholder (MOD019). */
export function isCodeOfConductLibraryId(libraryId: string | undefined | null): boolean {
  if (!libraryId) return false;
  const normalized = libraryId.startsWith('additional-') ? libraryId.slice('additional-'.length) : libraryId;
  return normalized === CODE_OF_CONDUCT_LIBRARY_ID;
}

export type CodeOfConductAssetRef = {
  id?: string;
  library_id: string;
  course_type?: string | null;
};

/**
 * True when a course detail route targets any Code of Conduct asset
 * (from the account-libraries `code-of-conduct` section or course_type).
 */
export function isCodeOfConductCourseAsset(
  courseId: string | undefined,
  codeOfConductAssets: CodeOfConductAssetRef[] | undefined,
): boolean {
  if (!courseId || !codeOfConductAssets?.length) return false;
  return codeOfConductAssets.some((asset) => asset.id === courseId || asset.library_id === courseId);
}

/** True for compliance_education course list items in the Code of Conduct section. */
export function isCodeOfConductCourseCategory(
  category: string | undefined,
  courseType?: string | null,
): boolean {
  return category === CODE_OF_CONDUCT_COURSE_CATEGORY || courseType === CODE_OF_CONDUCT_COURSE_TYPE;
}

/** Whether a standalone course has a user-selected topic (not the CoC placeholder). */
export function isStandaloneTopicSelected(courseType: string, libraryId: string): boolean {
  if (courseType === CODE_OF_CONDUCT_COURSE_TYPE) {
    return true;
  }
  return !!libraryId && libraryId !== CODE_OF_CONDUCT_LIBRARY_ID;
}
